module.exports = __webpack_public_path__ + "img/symbol_4.8d9d134f.png";